import { render, staticRenderFns } from "./Die_Services.vue?vue&type=template&id=3276e7c6&scoped=true"
import script from "./Die_Services.vue?vue&type=script&lang=js"
export * from "./Die_Services.vue?vue&type=script&lang=js"
import style0 from "./Die_Services.vue?vue&type=style&index=0&id=3276e7c6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3276e7c6",
  null
  
)

export default component.exports